import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import { TotalTran, TotalTranAnker, TranNum } from './styles'
import { TransactionStatus, TransactionStatusCode } from '../../../api/transaction/response'
import useAddressTransactionList from '../../../hooks/queries/useAddressTrasnsactionList'
import useAccountDetail from '../../../hooks/queries/useAccountDetail'
import usePagination from '../../../hooks/usePagination'
import { PAGE_SIZE } from '../../../constants'
import PageLoading from '../../../components/organisms/PageLoading'
import Divider from '../../../components/atoms/Divider'
import PaginationSingle from '../../../components/molecules/PaginationSingle'
import Table from '../../../components/molecules/Table'
import ContentsWrapper from '../../../components/organisms/ContentsWrapper'
import { roundDownFixedPoint, weiToEther } from '../../../utils/dataFormat'
import Button from '../../../components/atoms/Button'
import Icon from '../../../components/atoms/Icon'
import { getPageParams } from '../../../utils/params'

function Transactions() {
  const navigate = useNavigate()
  const { address = '' } = useParams()
  const [currentPage, setCurrentPage] = useState(getPageParams())
  const [transactionStatus, setTransactionStatus] = useState<TransactionStatus>(TransactionStatusCode.SUCCESS)

  // FIXME: API 호출 2번 발생
  const { isContract } = useAccountDetail(address)
  const {
    transactionList = [],
    totalPage = 0,
    totalTx = null,
    isLoading,
  } = useAddressTransactionList(address, currentPage, PAGE_SIZE, isContract ? transactionStatus : null)

  const { onNext, onPrev, onFirst, onLast } = usePagination({
    currentPage,
    setCurrentPage,
    totalPage,
  })

  const onClickTxInfo = (category: string, value: string) => {
    navigate(`/${category}/${value}`)
  }

  const onClickTxnStatus = (value: TransactionStatus) => {
    if (value !== transactionStatus) {
      onFirst()
      setTransactionStatus(value)
    }
  }

  return (
    <>
      <PageLoading loading={isLoading} />
      {isContract ? (
        <TotalTranAnker>
          <TotalTran>
            Latest 20 from a total of <TranNum>{totalTx}</TranNum> transactions
          </TotalTran>
          <Divider
            leftText="Completed Txns"
            rightText="Failed Txns"
            onClickLeft={() => onClickTxnStatus(TransactionStatusCode.SUCCESS)}
            onClickRight={() => onClickTxnStatus(TransactionStatusCode.FAILED)}
            leftActive={transactionStatus === TransactionStatusCode.SUCCESS}
            rightActive={transactionStatus === TransactionStatusCode.FAILED}
          />
        </TotalTranAnker>
      ) : (
        <TotalTranAnker>
          <TotalTran>
            <p>
              A total of <TranNum>{totalTx}</TranNum> transactions
            </p>
          </TotalTran>
          <PaginationSingle
            totalPage={totalPage}
            onClickFirstPage={onFirst}
            onClickLastPage={onLast}
            current={currentPage}
            onClickLeft={onPrev}
            onClickRight={onNext}
          />
        </TotalTranAnker>
      )}
      <ContentsWrapper>
        <Table
          columns={[
            { title: 'Txn hash', dataIndex: 'txHash', style: { maxWidth: '180px' } },
            { title: 'Method', dataIndex: 'method', style: { maxWidth: '123px' } },
            { title: 'Block', dataIndex: 'includedInBlock', style: { maxWidth: '133px' } },
            { title: 'Age', dataIndex: 'blockCreationTime', style: { maxWidth: '139px' } },
            { title: 'From', dataIndex: 'from', style: { maxWidth: '182px' } },
            { title: 'To', dataIndex: 'to', style: { maxWidth: '182px' } },
            { title: 'Value', dataIndex: 'value', style: { maxWidth: '69px' } },
          ]}
          dataSource={transactionList.map((tx) => {
            return {
              ...tx,
              txHash: (
                <>
                  {tx.status === TransactionStatusCode.FAILED ? <Icon name="fail" /> : ''}
                  <Button text={tx.txHash} onClick={() => onClickTxInfo('tx', tx.txHash)} />
                </>
              ),
              includedInBlock: (
                <Button text={tx.blockNumber} onClick={() => onClickTxInfo('block', tx.blockNumber.toString())} />
              ),
              blockCreationTime: <>{dayjs.unix(Number(tx.blockTimestamp)).fromNow()} </>,
              from:
                address !== tx.from.address ? (
                  <>
                    {tx.from.isContract && <Icon name="contractTable" />}
                    <Button text={tx.from.address} onClick={() => onClickTxInfo('account', tx.from.address)} />
                  </>
                ) : (
                  <>
                    {tx.from.isContract && <Icon name="contractTable" />}
                    {tx.from.address}
                  </>
                ),
              to:
                address !== tx.to?.address ? (
                  <>
                    {tx.to?.isContract && <Icon name="contractTable" />}
                    <Button text={tx.to?.address} onClick={() => onClickTxInfo('account', tx.to?.address ?? '')} />
                  </>
                ) : (
                  <>
                    {tx.to?.isContract && <Icon name="contractTable" />}
                    {tx.to?.address}
                  </>
                ),
              value: (
                <>
                  {roundDownFixedPoint(weiToEther(tx.value))} {tx.symbol}
                </>
              ),
            }
          })}
          loading={isLoading}
          goBackButtonVisible={false}
        />
      </ContentsWrapper>
      <PaginationSingle
        totalPage={totalPage}
        onClickFirstPage={onFirst}
        onClickLastPage={onLast}
        current={currentPage}
        onClickLeft={onPrev}
        onClickRight={onNext}
      />
    </>
  )
}

export default Transactions
